import { render, staticRenderFns } from "./BuilderNavigation.vue?vue&type=template&id=183d33df&scoped=true&"
import script from "./BuilderNavigation.vue?vue&type=script&lang=ts&"
export * from "./BuilderNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./BuilderNavigation.vue?vue&type=style&index=0&id=183d33df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d33df",
  null
  
)

export default component.exports